import { ReinosMaps } from './core'
import './maps'

window.REINOS_MAPS = new ReinosMaps
